import './search-by-title.scss';

export default () => {

    $('.search-by-title .search-field').on('keyup', function (e) {
        let search_value = $(this).val();
        let page_id = $(this).closest('.search-by-title').data('page-id');

        if ( search_value && search_value.length > 0 && page_id ) {
            $.ajax({
                url: ajax_obj.ajax_url,
                type: 'GET',
                data: {
                    'action': 'get_pages_by_title',
                    'search_value': search_value,
                    'page_id': page_id
                },
                success: function( response ) {
                    console.log(response);

                    if ( response && response.trim().length > 0 ) {
                        $('.search-by-title .search-results')
                            .html(response)
                            .removeClass('hidden');
                    } else {
                        $('.search-by-title .search-results')
                            .html('')
                            .addClass('hidden');
                    }
                },

                error: function( response ) {
                    console.log(response);
                }
            });
        } else {
            $('.search-by-title .search-results')
                .html('')
                .addClass('hidden');
        }
    });

    $(document).on('click', function (e) {
        let $target = $(e.target);

        if ( !$target.closest('.search-field').length ) {
            $('.search-by-title .search-results').addClass('hidden');
        } else {
            if ( $target.closest('.search-field').val().length === 0) {
                return false;
            }
            $('.search-by-title .search-results').removeClass('hidden');
        }
    });
};
